/** Micro-dollars as US dollars with two decimals, never localised (QZ-D55). */
export const formatMicroUsd = (microUsd: number): string => {
  if (microUsd === 0) {
    return '$0.00';
  }
  if (microUsd < 10_000) {
    return '<$0.01';
  }
  const cents = Math.round(microUsd / 10_000);
  const wholeDollars = Math.floor(cents / 100);
  const remainingCents = cents % 100;
  return `$${wholeDollars}.${String(remainingCents).padStart(2, '0')}`;
};

/** Micro-dollars as US dollars with three decimals, never localised: one task's cost (QZ-D113). */
export const formatMicroUsdFine = (microUsd: number): string => {
  if (microUsd === 0) {
    return '$0.000';
  }
  if (microUsd < 1_000) {
    return '<$0.001';
  }
  const tenthsOfCent = Math.round(microUsd / 1_000);
  const wholeDollars = Math.floor(tenthsOfCent / 1000);
  const remainingTenthsOfCent = tenthsOfCent % 1000;
  return `$${wholeDollars}.${String(remainingTenthsOfCent).padStart(3, '0')}`;
};
